
import Home from '../views/home'
export default Home;